import { Button } from '../ui/Button';
import { Modal } from '../ui/Modal';

interface ConfirmModalProps {
  isOpen?: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

export function ConfirmModal({
  isOpen = true,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
}: ConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div className="bg-white w-full max-w-md rounded-2xl shadow-xl animate-slide-up">
        <div className="px-6 py-4 border-b border-sage-200">
          <h3 className="font-display text-lg font-semibold text-forest-900">
            {title}
          </h3>
        </div>

        <div className="p-6">
          <p className="text-sage-700">{message}</p>
        </div>

        <div className="px-6 py-4 border-t border-sage-200 flex gap-3">
          <Button variant="ghost" className="flex-1" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button
            variant={danger ? 'danger' : 'primary'}
            className="flex-1"
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
